// extracted by mini-css-extract-plugin
export var footerWrapper = "styles-module--footer-wrapper--+PoqB";
export var footerContainer = "styles-module--footer-container--7vaVb";
export var footerTitle = "styles-module--footer-title--eZNzu";
export var footerText = "styles-module--footer-text--G70IU";
export var footerImg = "styles-module--footer-img--UHVgO";